import { Position, Range } from "plano";
import Globals from "../../globals";
import { store } from "./../../../store/store";
import { Caddy } from "./Caddy";
import { Component } from "./Component";
import { Shelf } from "./Shelf";
import { i18n } from "@/main";

const d3 = require("d3");

export class Module extends Component {
    _force = true;

    static async create(data, parent, duplicate = false) {
        let component = new Module(data, parent);
        component.isDuplicate = duplicate;
        component.type = Component.TYPE_MODULE;
        let cmp = await component._init(data);
        cmp._force = false;
        cmp._initModule();
        // cmp._draggable()
        return cmp;
    }

    static async createEditor(data, parentElt) {
        let component = new Module(data, null, true);
        component.type = Component.TYPE_MODULE;

        let elt = await component._loadSvg(component.data.src);
        elt.id = "editor_" + data.UUID;
        component.elt = elt;
        component.eltD3 = d3.select(elt);
        parentElt.append(elt);
        component._initModuleEditor();

        return component;
    }

    static getViewsActive() {
        return store.getters["plano/status/getViewsActive"];
    }

    async duplicate(parent = null) {
        let data = Globals.assign(this.data);
        let UUID = "module_" + Globals.UUID();
        data.UUID = UUID;
        data.x = data.x + 50;
        parent = parent === null ? this.parent : parent;
        let cmp = await Module.create(data, parent, true);
        cmp.isDuplicate = false;
        return cmp;
    }

    _initModule() {
        this._loadConstructPath();
        this._loadColors();
        this.visualComponent(this.data.highlight);
        this.viewRealistic(Module.getViewsActive().includes("realistic"));
    }

    _initModuleEditor() {
        this._loadConstructPath();
        this._loadColors();
    }

    _loadConstructPath() {
        let gFill = this.getElementD3().select("g#FILL");
        gFill.selectAll("path").select((d, i, cmps) => {
            d3.select(cmps[i]).attr("id", "path_" + i);
        });
        let { config } = this.data;
        if (config) {
            let { groups } = config;
            if (groups) {
                let rowId;
                let modules;
                groups.forEach((group, i) => {
                    rowId = "row_" + i;
                    group.rowId = rowId;

                    let gPath = gFill.append("g").attr("id", rowId);

                    modules = group.modules;

                    modules.forEach(pathId => {
                        let path = gFill.select("#" + pathId);
                        if (path.size() > 0) {
                            path.classed("grouped", true).classed(rowId, true);
                            if (pathId === group.tester) {
                                path.classed("tester", true);
                            }
                            gPath.node().append(path.node());
                        }
                    });
                });
            }
        }
    }

    _moduleBlackWhite(make) {
        let mods = ["MODULES"];
        let eltD3 = this.getElementD3();
        mods.forEach(mod => {
            eltD3.selectAll("#" + mod).attr("id", "MODULE");
            eltD3.selectAll("#" + mod.toLowerCase()).attr("id", "MODULE");
        });
        let mRect = eltD3.select("#MODULE").selectAll("rect");
        mRect.classed("bgWhite", make).attr("fill", "white");

        eltD3
            .select("#FILL")
            .selectAll("path")
            .classed("bgWhite", make);
    }

    loadColors() {
        this._loadColors();
    }

    _loadColors() {
        if (!this._force) {
            let views = Module.getViewsActive();
            this._moduleBlackWhite(!views.includes("color"));
        }

        let pathsG = this.getElementD3()
            .select("g#FILL")
            .selectAll("g")
            .filter((d, i, cmps) => {
                let cmp = cmps[i];
                return cmp.id.startsWith("row_");
            });

        pathsG.selectAll("path").select((d, i, cmps) => {
            let cmp = cmps[i];
            let pathD3 = d3.select(cmp);
            let row = cmp.parentNode;
            let colorData = this.getColor(row.id);
            if (colorData) this.pathColor(colorData, pathD3, this._force);
        });
    }

    _getGroupModules() {
        let modules = this.getAllComponentsChildren();
        modules.push(this);

        let parent = this.getParent();
        while (parent !== null && parent.type === Component.TYPE_MODULE) {
            modules.push(parent);
            parent = parent.getParent();
        }

        return modules;
    }

    _validateModule(pos) {
        let group = this.getGroup();
        let childrenOther = this._getGroupModules();
        let allChildren = group.getAllComponentsChildren().filter(cmp => cmp.type !== Component.TYPE_SHELF);
        let arrDiff = allChildren.filter(child => childrenOther.indexOf(child) < 0);
        let dimMod = this.getDimension(pos);
        return !arrDiff.some(cmp => {
            let dim = cmp.getDimension();
            return Component.conditionDimension(dim, dimMod);
        });
    }

    visualComponent(color) {
        this.data.highlight = color;
        this.loadHighLight();
    }

    loadHighLight() {
        let views = Module.getViewsActive();
        let elt = this.getElement();
        let bb = elt.getBBox();

        let rectVisual = d3.select(elt).select("rect#component-visual");
        let color = this.data.highlight;
        if (color === "cancel") {
            rectVisual.remove();
        } else if (color) {
            if (rectVisual.size() === 0) {
                rectVisual = d3
                    .select(elt)
                    .append("rect")
                    .attr("id", "component-visual")
                    .attr("fill-opacity", 0.1)
                    .attr("fill", color)
                    .attr("width", bb.width)
                    .attr("height", bb.height);
            }
            rectVisual.attr("fill", color);
        }

        rectVisual.attr("visibility", views.includes("highlights") ? "visible" : "hidden");
    }

    conditionOverHang(dim) {
        let condition = true;
        if (!Component.hasOverHang()) {
            let parent = this.getParent();
            if (parent instanceof Shelf) {
                let dimParent = parent.getDimension();
                condition = dim.x >= dimParent.x && dim.xEnd <= dimParent.xEnd;
            }
        }

        return condition;
    }

    validate(pos = null) {
        pos = pos === null ? { x: this.data.x, y: this.data.y } : pos;
        let validate = super.validate(pos);
        if (validate) {
            validate = this._validateModule(pos);
        }

        return validate;
    }

    setVisible(visible) {
        this.getElementD3().attr("visibility", visible ? "visible" : "hidden");
    }

    setConfig(config) {
        this.data.config = config;
        this._loadColors();
    }

    getConfig() {
        return this.data.config;
    }

    getColor(rowId) {
        let config = this.getConfig();
        let group = config.groups.find(g => g.rowId === rowId);
        return group && group.color ? group.color : null;
    }

    highlightContextMenu(textClicked) {
        let items = [
            { color: "#41B4E8", label: { fr: "Bleu", en: "Blue" } },
            { color: "#FF0000", label: { fr: "Rouge", en: "Red" } },
            { color: "#8A2BE1", label: { fr: "Violet", en: "Violet" } },
            { color: "#FFD600", label: { fr: "Jaune", en: "Yellow" } },
            { color: "#008000", label: { fr: "Vert", en: "Green" } },
            { color: "#000000", label: { fr: "Aucun", en: "None" } }
        ];
        this.createHighlightMenu(items, textClicked);
    }

    createHighlightMenu(items, cmp) {
        const event = d3.event;
        d3.select("div.content-menu-item").remove();
        let contentMenu = document.createElement("div");

        contentMenu.className = "content-menu";
        contentMenu.style.left = event.clientX + "px";
        contentMenu.style.top = event.clientY + "px";
        items.forEach(item => {
            let itemElt = document.createElement("div");
            let colorBadge = document.createElement("span");
            colorBadge.className = "badgeColorHighlight";
            colorBadge.style = "background-color:" + item.color;

            itemElt.className = "menu-item";
            let label = item.label[i18n.locale];
            itemElt.appendChild(colorBadge);
            itemElt.appendChild(document.createTextNode(label));
            contentMenu.appendChild(itemElt);

            d3.select(itemElt).on("click", () => {
                this.setShadeHighlight(item.color, cmp);
            });
        });
        document.body.appendChild(contentMenu);
        d3.select("body").on("click", () => {
            d3.selectAll("div.content-menu").remove();
        });
    }

    setShadeHighlight(color, elt) {
        let text = d3.select(elt);
        let data = this.data;
        let { config } = data;
        let { groups } = config;
        let group = groups.find(g => g.rowId === elt.parentNode.id);
        if (group) group.highlight = { color: color };
        text.attr("fill", color);
    }

    pathColor(colorData, pathD3, force = false) {
        if (colorData && colorData.color) {
            colorData.color.replace(new RegExp(" ", "g"), "").replace(new RegExp("&nbsp;", "g"), "");
        }
        let pathElt = pathD3.node();
        let parent = pathElt.parentNode;
        let parentD3 = d3.select(parent).data([colorData]);
        let text = parentD3.select("text");
        let views = Module.getViewsActive();
        let data = this.data;

        let { config } = data;
        let { groups } = config;

        let group = groups.find(g => g.rowId === parent.id);
        if (group) group.color = colorData;

        if (!views.includes("ref") && !force) {
            text.remove();
        }
        if (pathD3.attr("class").includes("tester") && (views.includes("ref") || force)) {
            pathD3.raise();
            let bb = pathElt.getBBox();
            pathD3.attr("fill", "white").style("fill", "white");
            if (text.size() === 0) {
                text = parentD3.append("text").raise();
                text.attr("class", "text-ref-shade");
                text.on("contextmenu", (data, i, elts) => {
                    d3.event.preventDefault();
                    let textClicked = elts[i];
                    this.highlightContextMenu(textClicked);
                });
            }

            let count = colorData.ref ? colorData.ref.length : 2;
            let fontSize = (bb.height < bb.width ? bb.height : bb.width) / count;
            let x = Math.round(bb.x + bb.width / 2);
            let y = Math.round(bb.y + (bb.height / 5) * 4);
            let textColor = (group.highlight && group.highlight.color) || "black";
            text.raise()
                .attr("x", x)
                .attr("y", y)
                .attr("font-size", fontSize)
                .style("font-size", fontSize)
                .attr("text-anchor", "middle")
                .attr("fill", textColor)
                .text(colorData.ref);
        } else {
            if (views.includes("color") || force) {
                let color = colorData.color;
                if (color.includes("|")) {
                    let colors = color.color.split("|");
                    let len = colors.length;
                    let offsetAvg = 100 / len;
                    let offset = 0;
                    let grads = colors.map(color => {
                        offset += Math.round(offsetAvg);
                        return { color: color, offset: offset };
                    });

                    let idGrad = parent.node().id + "_grad" + (force ? "_force" : "");
                    let defs = parent.select("defs");
                    if (defs.size() === 0) {
                        parentD3
                            .append("defs")
                            .lower()
                            .append("linearGradient")
                            .attr("id", idGrad)
                            .attr("x1", "0%")
                            .attr("x2", "75%")
                            .attr("y1", "0%")
                            .attr("y2", "75%")
                            .selectAll("stop.stop-grad")
                            .data(grads)
                            .enter()
                            .append("stop")
                            .attr("class", "stop-grad")
                            .attr("offset", (d, i) => {
                                return d.offset + "%";
                            })
                            .attr("stop-color", d => {
                                return d.color;
                            })
                            .attr("stop-opacity", 1);
                    }
                    pathElt.removeAttribute("style");
                    let classStr = pathElt.classList.toString();
                    let classes = classStr.split(" ");
                    classes.forEach(cl => {
                        if (cl !== "grouped" && !cl.includes("row_")) {
                            pathElt.classList.remove(cl);
                        }
                    });
                    pathD3.attr("fill", "url(#" + idGrad + ")");
                } else {
                    pathD3.attr("fill", color).style("fill", color);
                }
            } else {
                this.pathOrigin(pathD3);
            }
        }
    }

    pathOrigin(path) {
        let color = "#d3d3d3";
        path.attr("fill", color).style("fill", color);
    }

    //
    async viewRealistic(visible) {
        let { srcreal } = this.data;
        if (srcreal) {
            let id = "viexreal-" + this.data.UUID;
            let elt = this.getElement();
            let bb = elt.getBBox();
            let url = this._cleanUrl(srcreal);
            let img = this.getElementD3().select("#" + id);
            if (img.size() === 0) {
                let base64 = await Globals.urlToBase64(url);
                img = this.getElementD3()
                    .append("svg:image")
                    .attr("id", id)
                    .attr("class", "img-realistic")
                    .attr("width", bb.width)
                    .attr("height", bb.height)
                    .attr("href", base64);
            }

            img.raise();

            img.attr("visibility", visible ? "visible" : "hidden");
        }
    }

    draggable(event) {
        let pos = { x: event.x, y: event.y };
        this.toPositionDrag(pos);
    }

    toPositionDrag(position) {
        let data = this.data;
        data.x = position.x;
        data.y = position.y;

        this.getElementD3()
            .attr("x", d => {
                d.x = position.x;
                return position.x;
            })
            .attr("y", d => {
                d.y = position.y;
                return position.y;
            });

        let components = this.getComponents();
        components.forEach(component => {
            let posComponent = component.getPositionFromParent(position, data);
            component.toPositionDrag(posComponent);
        });

        return position;
    }

    getPositionSnap(pos) {
        // There's not a single line that I understand...

        if (!this.isParentDrag()) {
            let parent = this.getParent();
            let dim;
            let children = parent.getAllComponentsChildren();
            children.sort((child1, child2) => child2.data.x - child1.data.x);
            let modules = this._getGroupModules().sort((m1, m2) => m1.data.x - m2.data.x);
            children = children.filter(cmp => {
                dim = cmp.getDimension();
                return dim.xEnd < pos.x && !modules.includes(cmp);
            });

            // first child in the row
            if (children.length === 0) {
                // we apply the parent padding only here, or else there would be
                // a margin between components
                pos.x = parent.data.x + this.parent.data.padding.left;
            } else {
                // there are other components in the row
                let mod = modules[0];
                let y = mod.data.y;
                let { snapUp } = mod.data;
                let children2 = children
                    .filter(cmp => (snapUp ? cmp.data.y <= y : cmp.data.y >= y))
                    .sort((child1, child2) => child2.data.x - child1.data.x);
                if (children2.length > 0) children = children2;
                let child = children[0];
                let xParent = modules.length > 0 && mod.getParent().type === Component.TYPE_SHELF ? 0 : mod.data.xParent;
                pos.x = child.data.x + child.data.width + 1 - xParent;
            }
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }

    isOverflowingParent(pos) {
        // TODO: check if legacy shelfs still can receive modules
        // because due to the vertical collision check, they may not work anymore
        let dim = this.getDimension(pos);

        const destinationPosition = Position.fromLegacy(dim);
        const destinationSize = destinationPosition.toSized();

        let parentPosition = new Position({
            ...this.parent.position,
            // necessary trick to determine if a shelf is a caddy or not.
            // This is because the Component has no information about its categories, making it impossible
            // to differentiate between Shelf and Caddy
            //
            // This ensures that vertical collision is checked only for Caddy.
            y: !(this.parent instanceof Caddy)
                ? new Range({
                      from: 0,
                      to: 999999
                  })
                : this.parent.position.y
        });

        if (Component.hasOverHang()) {
            const res = parentPosition
                .add({
                    left: destinationSize.width,
                    right: destinationSize.width
                    // overhang is only horizontal
                })
                .isOverflowing(destinationPosition);
            return res;
        } else {
            const res = parentPosition.withPadding(this.parent.data.padding || {}).isOverflowing(destinationPosition);
            return res;
        }
    }

    canSnap(pos) {
        if (Component.allComponents.some(cmp => cmp.data.type === Component.TYPE_SHELF && cmp.data.isCaddy)) {
            return true;
        }

        const dim = this.getDimension(pos);
        if (!super.canSnap(pos) || this.isOverflowingParent(pos)) {
            return false;
        }

        const group = this.getGroup();
        return !Component.allComponents.some(cmp => {
            return (
                cmp !== this &&
                this.getParent() !== cmp &&
                cmp.type !== Component.TYPE_GROUP &&
                cmp.getGroup() !== group &&
                Component.conditionDimension(dim, cmp.getDimension())
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Module.js